import { aadSubscriptionStore } from "@root/stores/aad-subscription-store";
import { tenantAADStore } from "@root/data/auth/stores/tenant-aad-store";
import { computed } from "mobx";

export class AadSubscriptionsUiStore {
  @computed
  public get isFetching() {
    return tenantAADStore.isFetchingCollection || aadSubscriptionStore.isFetchingCollection;
  }

  @computed get subscriptions() {
    return aadSubscriptionStore.resources;
  }

  @computed get tenants() {
    return tenantAADStore.resources;
  }

  public fetchTenants() {
    return tenantAADStore.fetchCollection({ all: true });
  }

  public fetchSubscriptions(tenants) {
    return aadSubscriptionStore.fetchCollection({ tenants });
  }
}
